import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import NavigationButton from '../../Components/NavigationButton'
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import CenterBackImage from '../../Components/CenterBackImage';
import P from '../../Components/P';
import ContainerPage, {Routes} from "../ContainerPage";
import {BottomWrapper, CoreWrapper, InvisibleImage, TopWrapper} from "../../Components/Layout";
import PoweredBy from "../../Components/PoweredBy";

// PRE LOAD IMAGES
import EB_LOGO from '../../Assets/logo.svg';


import Toast from "../../Components/Toast";
import H2 from "../../Components/H2";
import {Helmet} from "react-helmet";
import Sizes from "../../Assets/Sizes";
import {CSSTransition} from "react-transition-group";
import ExistingMeetingPopOver from "../../Components/ExistingMeetingPopOver";
import {removeMeetings, setExistingMeetingsGroupMode} from "./Actions";
import {getSafely, isNonEmptyString} from "@tomeravni/easybizy-js-common/common";


const CustomP = styled(P)`
    max-width: 80%;
    font-weight: 300;
    ${p => p.theme.colors.textOnBackgroundImage ? `color: ${p.theme.colors.textOnBackgroundImage};` : ''}
`;

const HH1 = styled(H1)`
    ${p => p.theme.colors.textOnBackgroundImage ? `color: ${p.theme.colors.textOnBackgroundImage};` : ''}
`;

const HH2 = styled(H2)`
    ${p => p.theme.colors.textOnBackgroundImage ? `color: ${p.theme.colors.textOnBackgroundImage};` : ''}
`;

const HeadersWrapper = styled.div`
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};

    * {
        text-align: center;
    }
`;


const BGImageWrapper = styled.div.attrs({
    className: 'page__core-background-placeholder',
})`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: opacity 1s ease-in-out;
    opacity: 0;
    background-image: url('${p => p.url}');

`;

const SingleMultiButtonContainer = styled.div`
    display: flex;
    flex-grow: 1;

    > .page__navigation-button {
        flex-grow: 1;
    }
`


const MyTopWrapper = styled(TopWrapper)`
    .appear-enter {
        opacity: 0;
    }

    .appear-enter-active {
        opacity: 1;
        transition: all 500ms ease-in;
    }
`;

class Welcome extends ContainerPage {
    constructor(props) {
        super(props);
        this.allowAnonymous = true;
        this.nextRoute = Routes.pickServices;
        this.clearExistingMeetingsMode()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.config) {
            if (!nextProps.config.Customer) {
                this.nextRoute = Routes.identify;
            } else {
                this.nextRoute = Routes.pickServices;
            }
        }
    }

    setExistingMeetingGroup(mode, group) {
        this.props.setExistingMeetingsGroupMode(mode, group);

        if (mode === 'modify') {
            setTimeout(() => {
                this.pickTime()
            }, 500);
        }
    }

    navigateToSubBusiness(url) {
        window.location.replace(url);
    }

    render() {
        const businessMessage = this.props.intl.formatMessage({id: 'schedule.scheduleTitle'});
        const configLoaded = !!this.props.config;
        const ltr = !this.props.intl.locale.includes('he');
        const config = this.props.config || {};
        const customLogo = getSafely(['theme', 'properties', 'customLogo'], window)
        const bgImage = getSafely(['theme', 'properties', 'backgroundImage'], window);
        const hasBackgroundImage = isNonEmptyString(bgImage);
        const bgImageEl = hasBackgroundImage ? <BGImageWrapper url={bgImage}/> : null;

        const primaryBusinessSchedulingAction = getSafely(['PrimaryBusinessSchedulingActionLabel'], config);
        const secondaryBusinessTitle = getSafely(['SecondaryBusinessSchedulingActionLabel'], config);
        const secondaryBusinessUrl = getSafely(['SecondaryBusinessSchedulingActionUrl'], config);

        if (hasBackgroundImage) {
            const img = new Image();
            img.src = bgImage;

            img.onload = () => {
                const el = document.querySelector('.page__core-background-placeholder');
                if (el) {
                    el.style.opacity = 1;
                }
            };
        }


        /**
         *
         */

        return (
            <div className="transition-item detail-page detail-page__welcome">
                <Helmet>
                    <title>{`${businessMessage}${config.BusinessName || ''}`}</title>
                </Helmet>
                <CoreWrapper ltr={ltr} bgImageEl={bgImageEl}>
                    <MyTopWrapper>
                        <CSSTransition
                            in={configLoaded}
                            timeout={1000}
                            classNames="appear">
                            <HeadersWrapper className="page__headers-wrapper">
                                <HH1>
                                    {config.FirstPageDescriptionTopHeader || (configLoaded &&
                                        <FormattedMessage id="schedule.welcome"/>)}
                                </HH1>


                                <HH2 style={{whiteSpace: 'pre-wrap'}}>
                                    {config.FirstPageDescriptionSubHeader || ''}
                                </HH2>
                            </HeadersWrapper>
                        </CSSTransition>
                        <div>
                            <CenterBackImage loading={this.props.loading}
                                             transparent={isNonEmptyString(customLogo)}
                                             url={customLogo || (this.props.config && this.props.config.Logo) || ""}/>
                        </div>
                        <CSSTransition
                            in={configLoaded}
                            timeout={1000}
                            classNames="appear">
                            <CustomP className="detail-page__welcome-custom-p">
                                {config.FirstPageDescription || (configLoaded &&
                                    <FormattedMessage id="schedule.message"/>)}
                            </CustomP>
                        </CSSTransition>
                    </MyTopWrapper>
                    <BottomWrapper>
                        <SingleMultiButtonContainer>
                            {secondaryBusinessTitle && secondaryBusinessUrl &&
                                <NavigationButton
                                    click={() => this.navigateToSubBusiness(secondaryBusinessUrl)}>{secondaryBusinessTitle}</NavigationButton>

                            }

                            <NavigationButton
                                disabled={this.props.loading || !this.props.configWithServices}
                                click={() => this.next()}>{primaryBusinessSchedulingAction || <FormattedMessage
                                id="schedule.start"/>}</NavigationButton>

                        </SingleMultiButtonContainer>
                        <PoweredBy
                            hasBackgroundImage={hasBackgroundImage}
                            showTerms={true} config={this.props.config}/>
                    </BottomWrapper>
                    <InvisibleImage src={EB_LOGO}/>
                </CoreWrapper>
                < Toast ref={(toast) => this.toast = toast}/>
                <ExistingMeetingPopOver config={this.props.configWithServices}
                                        existingMeetings={this.props.existingMeetings}
                                        allowAdditionalMeetings={this.props.allowAdditionalMeetings}
                                        hidden={!this.props.hasOtherMeetings}
                                        removeMeetings={(meetings, callback) => this.props.removeMeetings(meetings, callback)}
                                        setExistingMeetingsGroupMode={(mode, group) => this.setExistingMeetingGroup(mode, group)}/>

            </div>
        )
    }
}


/** Styled-Components **/


/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingConfig,
        config: state.schedule.config,
        configWithServices: state.schedule.configWithServices,
        scheduleState: state.schedule.scheduleState,
        hasOtherMeetings: state.schedule.hasOtherMeetings,
        allowAdditionalMeetings: state.schedule.allowAdditionalMeetings,
        existingMeetings: state.schedule.nextExistingMeetings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        removeMeetings: (meetings, callback) => dispatch(removeMeetings(meetings, callback)),
        setExistingMeetingsGroupMode: (mode, group) => dispatch(setExistingMeetingsGroupMode(mode, group)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Welcome));
